import httpAdapter, {
  ApiVersion,
  ContentType,
  HttpMethod,
} from "../../utils/http-adaper";

const UserApi = {
  updateUserPreferences: async ({ memberId, preferences }) => {
    const response = await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/user/${memberId}/preferences`,
      authneticated: true,
      body: preferences,
      contentType: ContentType.JSON,
    });
    return response;
  },
  verifyPhoneOtp: async ({ data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: "admin/update_phonenumber",
      contentType: ContentType.FORM_URL_ENCODED,
      body: data,
      authneticated: true,
    });
  },
  checkUserExists: async ({ searchParams }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "auth/user_exists",
      queryParams: searchParams,
      authneticated: true,
    });
  },
  triggerPhoneNumberChangeOtp: async ({
    authneticated,
    data,
    xTimestamp,
    xClientId,
  }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: "phonenumbers",
      authneticated: authneticated,
      headers: { "x-timestamp": xTimestamp, "x-client-id": xClientId },
      body: data,
      ContentType: ContentType.FORM_URL_ENCODED,
    });
  },
  updateUserPassword: async ({ memberId, password }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/user/${memberId}/update_password`,
      contentType: ContentType.FORM_URL_ENCODED,
      body: password,
      authneticated: true,
    });
  },
};

export default UserApi;
